// Import gql helper and craft a GraphQL query
import { API, graphqlOperation } from "aws-amplify";

const FlightsQuery = (airline = "440") => {
  return /* GraphQL */ `
query MyQuery($nextToken: String) {
  listFlights(
    limit: 1000,
    nextToken: $nextToken,
    filter: {
      airlineID: {eq: "${airline}"}
    }
  ) {
    items {
      airlineID
      id
      location
      number
    }
    nextToken
  }
}
`;
};

const CodesQuery = /* GraphQL */ `
  query CodesList {
    listSecondarys {
      items {
        id
        number
        text
      }
    }
  }
`;
const AirlinesQuery = () => {
  return `
query AirlinesList {
  listAirlines {
    items {
      id
      name
      abbreviation
    }
  }
}
`;
};

export const getCodes = () => API.graphql(graphqlOperation(CodesQuery));
export const getAirlines = () => API.graphql(graphqlOperation(AirlinesQuery()));
export const getFlightsByAirline = async (airline) => {
  let allItems = [];
  let nextToken = null;
  do {
    const result = await API.graphql(
      graphqlOperation(FlightsQuery(airline), { nextToken })
    );
    const page = result.data.listFlights;
    allItems = allItems.concat(page.items || []);
    nextToken = page.nextToken;
  } while (nextToken);
  return { data: { listFlights: { items: allItems } } };
};
